// Titan email connections (MA-55): the pure half of the Integrations screen's Titan card.
//
// Titan has no OAuth, so unlike Gmail there is no redirect: the business types the mailbox's
// password (or a Titan application password) and the backend logs in over IMAP before storing
// anything. These helpers decide what the form sends and what a connection's state reads as.

// Where the mailbox was bought decides which server it lives on. The backend accepts one of these
// keys, never a hostname. The hosts are shown so a customer can match them against their
// provider's settings page. GoDaddy serves its "Professional Email powered by Titan" from its own
// host, and Titan's host rejects those accounts as a wrong password.
export const TITAN_REGIONS = [
  { value: "global", label: "Titan, Hostinger, Namecheap u otro (imap.titan.email)" },
  { value: "godaddy", label: "GoDaddy (imap.secureserver.net)" },
  { value: "eu", label: "Proveedor europeo (imap0101.titan.email)" },
];

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// What a connection's `status` means to the person looking at the screen. `tone` is the
// Integrations table's existing pill class (`connection-status active|expired`), so a Titan row
// reads like a Gmail row. `AUTH_FAILED` is the one that needs them: the backend stops polling
// that mailbox until it is reconnected, because retrying a wrong password every minute is how a
// mailbox gets locked.
export const titanStatus = (connection) => {
  switch (connection && connection.status) {
    case "ACTIVE":
      return { label: "Activo", tone: "active", needsReconnect: false };
    case "AUTH_FAILED":
      return { label: "Credenciales inválidas", tone: "expired", needsReconnect: true };
    case "ERROR":
      return { label: "Error de conexión", tone: "expired", needsReconnect: false };
    default:
      return { label: "Sin verificar", tone: "expired", needsReconnect: false };
  }
};

// Checked before the request, so an obvious typo does not spend one of the credential rate
// limit's attempts. The password is not trimmed: a space can be part of it.
export const validateTitanForm = ({ email, password, region }) => {
  if (!EMAIL_PATTERN.test((email || "").trim())) return "Ingresa un correo válido.";
  if (!password) return "Ingresa la contraseña del buzón o una contraseña de aplicación.";
  if (!TITAN_REGIONS.some((option) => option.value === region)) return "Elige dónde compraste tu correo Titan.";
  return null;
};

// The request body. Never `mantisBusinessId`: the backend takes the business from the session,
// and sending one would suggest it is read.
export const titanConnectPayload = ({ email, password, region }) => ({
  email: (email || "").trim(),
  password,
  region,
});

// What to tell the person when a call did not succeed, or `null` when it did. The backend's
// message is written for them (in Spanish, with Titan's setup hints on a rejected password), so it
// wins over the fallback. `undefined` is what `fetchWrapper` returns on a 401, after it has
// already sent the user to log in.
export const titanErrorMessage = (
  response,
  fallback = "No pudimos conectar el buzón. Intenta de nuevo."
) => {
  if (response && response.success) return null;
  if (response && response.message) return response.message;
  return fallback;
};
